import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Avatar, IconInformation, Typography } from '@klarna/bubble-ui';
import { AvatarAnimation } from './AvatarAnimation';
import { TooltipAnimation } from './TooltipAnimation';

const chatbotImage =
  // eslint-disable-next-line max-len
  'data:image/svg+xml;base64,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';

const getStyles = ({ tooltipBottomOverride = undefined, tooltipWidth = undefined }) => ({
  relative: { position: 'relative', width: tooltipWidth },
  tooltip: {
    position: 'absolute',
    right: '0px',
    bottom: tooltipBottomOverride || '10px',
    zIndex: 100,
  },
  overlay: {
    position: 'absolute',
    right: '15px',
    bottom: '40px',
    width: '250px',
    background: 'rgb(23, 23, 23)',
    padding: '10px 15px 12px 15px',
    borderRadius: '15px 15px 0 15px',
  },
});

export const TOOLTIP_MODES = {
  ERROR_ONLY: 'ERROR_ONLY',
  HELPER: 'HELPER',
  ICON: 'ICON',
};

export const withTooltip = (
  WrappedComponent,
  { tooltipBottomOverride = false, tooltipWidth = undefined } = {},
) => {
  const TooltipWrapper = ({
    error = false,
    tooltipText = undefined,
    tooltipMode = TOOLTIP_MODES.ERROR_ONLY,
    value = '',
    onBlur = () => null,
    onFocus = () => null,
    ...props
  }) => {
    const [isFocused, setIsFocused] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const inputProps = {
      error,
      onBlur: () => {
        setIsFocused(false);
        onBlur();
      },
      onFocus: () => {
        setIsFocused(true);
        onFocus();
      },
      value,
    };

    let shouldShowTooltip = false;

    switch (tooltipMode) {
      case TOOLTIP_MODES.HELPER: {
        shouldShowTooltip = isFocused;
        break;
      }
      case TOOLTIP_MODES.ERROR_ONLY: {
        shouldShowTooltip = isFocused && !!value && error;
        break;
      }
      case TOOLTIP_MODES.ICON: {
        shouldShowTooltip = isHovered;
        break;
      }
    }

    const styles = getStyles({ tooltipBottomOverride, tooltipWidth });

    return (
      <div style={styles.relative}>
        <WrappedComponent {...props} {...inputProps} />
        {tooltipText && (
          <div style={styles.tooltip}>
            <div style={styles.relative}>
              {tooltipMode !== TOOLTIP_MODES.ICON && (
                <AvatarAnimation shouldShowTooltip={shouldShowTooltip}>
                  <Avatar small source={chatbotImage} fallbackCharacter="K" altText="Chatbot" />
                </AvatarAnimation>
              )}
              {tooltipMode === TOOLTIP_MODES.ICON && (
                <IconInformation
                  colorToken="colors/text/neutral"
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                />
              )}
              <TooltipAnimation shouldShowTooltip={shouldShowTooltip}>
                <div style={styles.overlay}>
                  <Typography
                    textToken="text-style/text/paragraphs/body/regular"
                    colorToken="colors/text/inverse"
                  >
                    {tooltipText}
                  </Typography>
                </div>
              </TooltipAnimation>
            </div>
          </div>
        )}
      </div>
    );
  };

  TooltipWrapper.propTypes = {
    error: PropTypes.bool,
    tooltipMode: PropTypes.string,
    tooltipText: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
  };

  return TooltipWrapper;
};
